import CoreEventDetails from './CoreEventDetails';

export { type CoreEventDetailsProps } from './CoreEventDetails';
export default CoreEventDetails;
